import React, { useState, useEffect,useRef } from 'react';
import api from '../api';
import Table from '../components/Table';
import Modal from '../components/Modal';
import ImageUpload from '../components/ImageUpload';
import { FiPlus, FiUser, FiMail, FiTag, FiAward, FiBook, FiPhone, FiMapPin, FiList,FiChevronDown } from 'react-icons/fi';
import toast from 'react-hot-toast';

const FormGroup = ({ children, cols = 1 }) => {
  const colClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-3',
  };
  return (
    <div className={`grid ${colClasses[cols]} gap-6 mb-6`}>
      {children}
    </div>
  );
};

const InputField = ({ icon, label, name, type = 'text', value, onChange, required = true, options, multiple = false }) => (
  <div>
    <label htmlFor={name} className="block text-sm font-medium text-gray-700 mb-1">
      {label}
    </label>
    <div className="mt-1 relative rounded-md shadow-sm">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        {icon}
      </div>
      {options ? (
        <select
          name={name}
          id={name}
          value={value}
          onChange={onChange}
          className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 pr-10 py-2 text-base border-gray-300 rounded-md"
          required={required}
          multiple={multiple}
        >
          {!multiple && <option value="">Select {label}</option>}
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          name={name}
          id={name}
          value={value}
          onChange={onChange}
          className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
          required={required}
        />
      )}
    </div>
  </div>
);
const MultiSelect = ({ options, value, onChange, label, icon }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggle = (optionValue) => {
    const newValue = value.includes(optionValue)
      ? value.filter(v => v !== optionValue)
      : [...value, optionValue];
    onChange({ target: { name: 'colleges', value: newValue } });
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <button
        type="button"
        className="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-10 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          {icon}
        </span>
        <span className="block truncate">
          {value.length === 0 ? `Select ${label}` : `${value.length} selected`}
        </span>
        <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <FiChevronDown className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </span>
      </button>
      {isOpen && (
        <div className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
          {options.map((option) => (
            <div
              key={option.value}
              className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => handleToggle(option.value)}
            >
              <input
                type="checkbox"
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                checked={value.includes(option.value)}
                readOnly
              />
              <label className="ml-3 block text-sm text-gray-700">
                {option.label}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const Coordinators = () => {
  const [coordinators, setCoordinators] = useState([]);
  const [colleges, setColleges] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentCoordinator, setCurrentCoordinator] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    coordinatorType: '',
    mmpsrcDesignation: '',
    collegeDesignation: '',
    colleges: [],
    extensionNumber: '',
    profilePic: '',
    seatingPosition: '',
    order: '',
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    pages: 0,
  });
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchCoordinators();
    fetchColleges();
  }, [pagination.page, pagination.limit, searchTerm]);

  const fetchCoordinators = async () => {
    try {
      const response = await api.get('/coordinator', {
        params: {
          page: pagination.page,
          limit: pagination.limit,
          search: searchTerm,
        },
      });
      setCoordinators(response.data.data);
      setPagination(prevState => ({
        ...prevState,
        total: response.data.pagination.total,
        pages: response.data.pagination.pages,
      }));
    } catch (error) {
      toast.error('Failed to fetch coordinators');
    }
  };

  const fetchColleges = async () => {
    try {
      const response = await api.get('/college');
      setColleges(response.data.data);
    } catch (error) {
      toast.error('Failed to fetch colleges');
    }
  };

  const handlePageChange = (newPage) => {
    setPagination(prevState => ({ ...prevState, page: newPage }));
  };

  const handleLimitChange = (newLimit) => {
    setPagination(prevState => ({ ...prevState, limit: newLimit, page: 1 }));
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setPagination(prevState => ({ ...prevState, page: 1 }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleProfilePicUpload = (urls) => {
    setFormData(prevState => ({ ...prevState, profilePic: urls[0] }));
  };

  const handleProfilePicRemove = () => {
    setFormData(prevState => ({ ...prevState, profilePic: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (currentCoordinator) {
        await api.put(`/coordinator/${currentCoordinator._id}`, formData);
        toast.success('Coordinator updated successfully');
      } else {
        await api.post('/coordinator', formData);
        toast.success('Coordinator created successfully');
      }
      setIsModalOpen(false);
      fetchCoordinators();
    } catch (error) {
      toast.error('Failed to save coordinator');
    }
  };

  const handleEdit = (coordinator) => {
    setCurrentCoordinator(coordinator);
    setFormData({
      name: coordinator.name,
      email: coordinator.email,
      coordinatorType: coordinator.coordinatorType,
      mmpsrcDesignation: coordinator.mmpsrcDesignation,
      collegeDesignation: coordinator.collegeDesignation,
      colleges: coordinator.colleges.map(college => college._id),
      extensionNumber: coordinator.extensionNumber,
      profilePic: coordinator.profilePic,
      seatingPosition: coordinator.seatingPosition,
      order: coordinator.order,
    });
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this coordinator?')) {
      try {
        await api.delete(`/coordinator/${id}`);
        toast.success('Coordinator deleted successfully');
        fetchCoordinators();
      } catch (error) {
        toast.error('Failed to delete coordinator');
      }
    }
  };

  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'email', label: 'Email' },
    { key: 'coordinatorType', label: 'Coordinator Type' },
    { key: 'mmpsrcDesignation', label: 'MMPSRC Designation' },
    { key: 'collegeDesignation', label: 'College Designation' },
    { key: 'colleges', label: 'Colleges', render: (item) => item.colleges.map(college => college.name).join(', ') },
    { key: 'seatingPosition', label: 'Seating Position' },
    { key: 'order', label: 'Order' },
    { 
      key: 'profilePic', 
      label: 'Profile Picture', 
      render: (item) => <img src={item.profilePic} alt={item.name} className="w-10 h-10 rounded-full object-cover" />
    },
  ];




  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Coordinators</h1>
        <button
          onClick={() => {
            setCurrentCoordinator(null);
            setFormData({
              name: '',
              email: '',
              coordinatorType: '',
              mmpsrcDesignation: '',
              collegeDesignation: '',
              colleges: [],
              extensionNumber: '',
              profilePic: '',
              seatingPosition: '',
              order: '',
            });
            setIsModalOpen(true);
          }}
          className="px-4 py-2 font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-150 ease-in-out"
        >
          <FiPlus className="inline-block mr-2" />
          Add Coordinator
        </button>
      </div>
      <Table
        columns={columns}
        data={coordinators}
        onEdit={handleEdit}
        onDelete={handleDelete}
        pagination={pagination}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        onSearch={handleSearch}
      />
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={currentCoordinator ? 'Edit Coordinator' : 'Add Coordinator'} size="xl">
        <form onSubmit={handleSubmit} className="space-y-6">
          <FormGroup cols={2}>
            <InputField
              icon={<FiUser className="h-5 w-5 text-gray-400" />}
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
            />
            <InputField
              icon={<FiMail className="h-5 w-5 text-gray-400" />}
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
            />
          </FormGroup>
          <FormGroup cols={2}>
            <InputField
              icon={<FiTag className="h-5 w-5 text-gray-400" />}
              label="Coordinator Type"
              name="coordinatorType"
              value={formData.coordinatorType}
              onChange={handleInputChange}
              options={[
                { value: 'main', label: 'Main' },
                { value: 'faculty', label: 'Faculty' },
              ]}
            />
            <InputField
              icon={<FiAward className="h-5 w-5 text-gray-400" />}
              label="MMPSRC Designation"
              name="mmpsrcDesignation"
              value={formData.mmpsrcDesignation}
              onChange={handleInputChange}
            />
          </FormGroup>
          <FormGroup cols={2}>
            <InputField
              icon={<FiAward className="h-5 w-5 text-gray-400" />}
              label="College Designation"
              name="collegeDesignation"
              value={formData.collegeDesignation}
              onChange={handleInputChange}
            />
            <MultiSelect
              options={colleges.map(college => ({ value: college._id, label: college.name }))}
              value={formData.colleges}
              onChange={handleInputChange}
              label="Colleges"
              icon={<FiBook className="h-5 w-5 text-gray-400" />}
            />
          </FormGroup>
          <FormGroup cols={3}>
            <InputField
              icon={<FiPhone className="h-5 w-5 text-gray-400" />}
              label="Extension Number"
              name="extensionNumber"
              value={formData.extensionNumber}
              onChange={handleInputChange}
              required={false}
            />
            <InputField
              icon={<FiMapPin className="h-5 w-5 text-gray-400" />}
              label="Seating Position"
              name="seatingPosition"
              value={formData.seatingPosition}
              onChange={handleInputChange}
            />
            <InputField
              icon={<FiList className="h-5 w-5 text-gray-400" />}
              label="Order"
              name="order"
              type="number"
              value={formData.order}
              onChange={handleInputChange}
            />
          </FormGroup>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Profile Picture</label>
            <ImageUpload
              onUpload={handleProfilePicUpload}
              onRemove={handleProfilePicRemove}
              images={formData.profilePic ? [formData.profilePic] : []}
            />
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => setIsModalOpen(false)}
              className="mr-3 px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              {currentCoordinator ? 'Update' : 'Create'}
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default Coordinators;